import { lazy } from "react";
import LazyLoad from "../common/LazyLoad";
import AdminLayout from "./AdminLayout";
const Dashboard = LazyLoad(lazy(() => import("../pages/dashboard")));
const CaseStudies = LazyLoad(lazy(() => import("../pages/case-studies")));
const AddCaseStudies = LazyLoad(
  lazy(() => import("../pages/case-studies/AddCaseStudies"))
);
const FileManager = LazyLoad(lazy(() => import("../pages/file-manager")));
const UserProfile = LazyLoad(lazy(() => import("../pages/user-profile")));

const AdminRoutes = {
  path: "/app",
  element: <AdminLayout />,
  children: [
    {
      path: "/app",
      element: <Dashboard sdf="sdf" />,
    },
    {
      path: "/app/case-studies",
      element: <CaseStudies />,
    },
    {
      path: "/app/add-case-studies",
      element: <AddCaseStudies />,
    },
    {
      path: "/app/file-manager",
      element: <FileManager />,
    },
    {
      path: "/app/user-profile",
      element: <UserProfile/>
    }
  ],
};

export default AdminRoutes;
